/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerUpdateMutationRequest, RegionsControllerUpdateMutationResponse, RegionsControllerUpdatePathParams, RegionsControllerUpdate400, RegionsControllerUpdate401, RegionsControllerUpdate403, RegionsControllerUpdate404 } from "../../models/regionsController/RegionsControllerUpdate";

function getRegionsControllerUpdateUrl(id: RegionsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/regions/${id}` as const }  
  return res
}

/**
 * @summary Update a region
 * {@link /api/v1/regions/:id}
 */
export async function regionsControllerUpdate(id: RegionsControllerUpdatePathParams["id"], data?: RegionsControllerUpdateMutationRequest, config: Partial<RequestConfig<RegionsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<RegionsControllerUpdateMutationResponse, ResponseErrorConfig<RegionsControllerUpdate400 | RegionsControllerUpdate401 | RegionsControllerUpdate403 | RegionsControllerUpdate404>, RegionsControllerUpdateMutationRequest>({ method : "PATCH", url : getRegionsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}